import { createAsyncThunk } from "@reduxjs/toolkit";
import { CondimentService } from "../../services/CondimentService";
import { AxiosError } from "axios";
import { CondimentInterface } from "../../entities/Condiment";
import { transformCondiments } from "../../utils/transformCondiments";

export const fetchOneCondimentById = createAsyncThunk<
  CondimentInterface,
  string,
  { rejectValue: AxiosError }
>(
  "condiment/fetchOneCondimentById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await CondimentService.getCondiment(id);

      const transformedResponse = {
        ...response,
        id: response.condimentId ?? response.id,
      };

      const condimentInArray = transformCondiments([transformedResponse]);

      return condimentInArray[0];
    } catch (e: any) {
      return rejectWithValue(e.message as AxiosError);
    }
  },
);
